import { useAuth } from "./useAuth";
import { useTicketsRealtime } from "./useTickets";
import { useInboxRealtime } from "./useInbox";
import { useWaitingRoomRealtime } from "./useWaitingRoom";
import { usePhoneRealtime } from "./usePhone";
import { usePatientsRealtime } from "./usePatients";
import { useDoctorsRealtime, useResourcesRealtime } from "./useCalendarResources";

/**
 * Global Realtime Orchestrator
 * Mount this exactly once (e.g. in AppShell) to keep the global React Query cache
 * perfectly synchronized with Supabase Postgres Changes across all tabs and components.
 */
export function useGlobalRealtime() {
    const { user } = useAuth();
    const practiceId = user?.practiceId;

    // Connect domain-specific realtime listeners
    useTicketsRealtime(practiceId);
    useInboxRealtime(practiceId);
    useWaitingRoomRealtime(practiceId);
    usePhoneRealtime(practiceId);
    usePatientsRealtime(practiceId);
    useDoctorsRealtime(practiceId);
    useResourcesRealtime(practiceId);
}
